import * as React from 'react';
import Grid from '@mui/material/Grid';
import TitleGrid from './TitleGrid';
import PointChart from './PointChart';
import ReportSummary from './ReportSummary';
import { reportTypes } from '../constants/reportTypes';

//Gün Döngüsü
/* function getDailyScore(carJson, day) {
  var result = 0;
    carJson.forEach(day2 => {
    Object.entries(day2).forEach(([key, value]) => {
      if (day2.name === day) {
        result = day2.score;
      }
    });
  });
  return (result);
} */

function removeDuplicates(arr) {
  return arr.filter((item, index) => arr.indexOf(item) === index);
}

function sortDates(dateArray) {
  return dateArray.sort((dateStr1, dateStr2) => {
    const [day1, month1, year1] = dateStr1.split('.').map(Number);
    const [day2, month2, year2] = dateStr2.split('.').map(Number);

    // Note: The date format is 'dd.mm.yyyy', so we are constructing Date objects in the 'yyyy, mm, dd' format.
    const date1 = new Date(year1, month1 - 1, day1);
    const date2 = new Date(year2, month2 - 1, day2);

    return date1 - date2;
  });
}

function calculateAverage(arr) {
  let sum = [];
  let res = 0;
  arr.forEach((element) => {
    if (
      typeof element !== 'undefined' &&
      element !== null &&
      element !== 'NaN'
    ) {
      sum.push(element);
    }
  });
  sum.length > 0 ? (res = sum.reduce((a, b) => a + b)) : (res = null);
  if (res !== null) {
    return res / sum.length;
  }
  return res;
}

function jsonToPoint(json) {
  /* 	const plateList = ['Gün'];
    const monList = [];
    const tueList = [];
    const wedList = [];
    const thuList = [];
    const friList = []; */

  //console.log(json, 'json')
  //let scoredata = json?.data[0]?.data
  let data = [];
  let columnIndex = [];

  // Son 6 Aylık Point Chart için
  if (json[0]?.dateTitle) {
    let avg =
      calculateAverage(json.map((x) => x?.score)) !== null
        ? '(% ' + calculateAverage(json.map((x) => x?.score)).toFixed(2) + ')'
        : '(-)';

    json?.forEach((el) => {
      //let option = el?.score !== 100 ? 'point {  shape-type: point; fill-color: red; }' : 'point {  shape-type: point; fill-color: green; }'
      data.push([el?.dateTitle, el?.score, '%' + el?.score]);
    });

    // Column Index
    data.push([
      'Tarih Aralığı',
      `Ortalama Güvenlik Skoru ${avg}`,
      { role: 'annotation', type: 'string' },
    ]);
    data.reverse();
    return data;
  }

  columnIndex.push('Gün');

  const avgScores = json.data.sort((a, b) => b.score - a.score);

  avgScores?.forEach((el) => {
    let avg = el?.score !== undefined ? '(% ' + el?.score + ')' : '(-)';
    columnIndex.push(el?.plate + ` ${avg}`);
    columnIndex.push({ role: 'annotation', type: 'string' });
  });

  data.push(columnIndex);

  let days = [];
  json?.data?.forEach((el) => {
    el?.data?.forEach((element) => {
      days.push(element?.name);
    });
    //Aynı günleri silme
    days = removeDuplicates(days);
    days = sortDates(days);
  });

  //console.log(days, 'days')
  //console.log(scores, 'scores')

  days?.forEach((element, index) => {
    let point = [element];

    json?.data?.forEach((el, i) => {
      let score = el?.data?.find((x) => x.name === element)
        ? el?.data?.find((x) => x.name === element)
        : { score: null };
      let option =
        score?.score !== 100
          ? 'point {  shape-type: point; fill-color: red; }'
          : 'point {  shape-type: point; fill-color: green; }';
      if (score?.score === undefined) {
        score.score = NaN;
      }
      point.push(score?.score, '%' + score?.score);
    });

    data.push(point);
  });

  //console.log(data, 'data')

  /* 	// Araç Döngüsü
  json.data.forEach(car => {

    plateList.push(car.plate);
    plateList.push({ 'type': 'string', 'role': 'style' });
    monList.push(getDailyScore(car.data, "mon"));
    monList.push(getDailyScore(car.data, "mon") !== 100 ?
      'point {  shape-type: point; fill-color: red; }'
      :
      'point {  shape-type: point; fill-color: green; }');
    tueList.push(getDailyScore(car.data, "tue"));
    tueList.push(getDailyScore(car.data, "tue") !== 100 ?
      'point {  shape-type: point; fill-color: red; }'
      :
      'point {  shape-type: point; fill-color: green; }');
    wedList.push(getDailyScore(car.data, "wed"));
    wedList.push(getDailyScore(car.data, "wed") !== 100 ?
      'point {  shape-type: point; fill-color: red; }'
      :
      'point {  shape-type: point; fill-color: green; }');
    thuList.push(getDailyScore(car.data, "thu"));
    thuList.push(getDailyScore(car.data, "thu") !== 100 ?
      'point {  shape-type: point; fill-color: red; }'
      :
      'point {  shape-type: point; fill-color: green; }');
    friList.push(getDailyScore(car.data, "fri"));
    friList.push(getDailyScore(car.data, "fri") !== 100 ?
      'point {  shape-type: point; fill-color: red; }'
      :
      'point {  shape-type: point; fill-color: green; }');
  }); */
  // console.log(data);
  return data;
  /* 	return (
      [plateList, monList, tueList, wedList, thuList, friList]
    ); */
}

const VehicleChartTable = (props) => {
  const title = props.title;
  const title2 = props.title2;
  const pointJson = props.json;
  const rawData = props.rawData;
  const carData = props.carData;
  const reportType =
    rawData?.request.schema.id === reportTypes.KV_Fleet_Report
      ? { tr: 'Filo', en: 'Fleet' }
      : { tr: 'Araç', en: 'Vehicle' };

  const data = jsonToPoint(pointJson);
  return (
    <>
      <Grid
        container
        spacing={2}
        style={{
          marginBottom: 10,
        }}
      >
        <TitleGrid
          title={title}
          title2={title2}
          widthRate={12}
          padding={1}
          titleFontSize="h6"
        />
        <PointChart
          data={data}
          widthRate={12}
          chartSize={
            carData?.length <= 10 ? 80 : carData?.length <= 15 ? 55 : 50
          }
        />
      </Grid>
      {reportType.tr === 'Filo' && (
        <ReportSummary
          carData={carData}
          pointJson={pointJson}
          rawData={rawData}
          chartData={data}
        />
      )}
    </>
  );
};

export default VehicleChartTable;
